import { t } from 'localization'
import { Hit } from 'react-instantsearch-core'
import { AlgoliaIndex } from 'search'
import AlgoliaSearchClient from 'search/components/AlgoliaSearchClient'
import PageLevelInstantSearch from 'search/components/PageLevelInstantSearch'
import ProductHits, { Hits } from 'search/components/ProductHits'
import { ResultsState } from 'search/types/ResultState'
import { SearchHit } from 'search/utils/mapHitsToProducts'
import Button from 'shared/components/Button'
import { SearchQA } from 'shared/dataAttributes'
import { fonts, media, pageWidth, styles } from 'shared/lib'
import styled from 'styled-components'

const TP = 'search.components.TrendingProducts'

type TrendingProductsProps = {
  resultsState?: ResultsState
  isAlgolia?: boolean
  hits?: Hit<SearchHit>[]
}

const TrendingProducts = ({ resultsState, isAlgolia, hits }: TrendingProductsProps) => {
  if (isAlgolia === false) {
    return (
      <Container>
        <Title data-qa={SearchQA.GridTitleNameTrending}>{t(`${TP}.trending`, 'Trending')}</Title>

        <Hits hits={hits || []} isAlgolia={isAlgolia} />

        <SeeAllButtonContainer>
          <Button buttonType="primary1" data-qa={SearchQA.GridShopAllTrendingLink} href="/trending">
            {t(`${TP}.shopAllTrending`, 'Shop All Trending')}
          </Button>
        </SeeAllButtonContainer>
      </Container>
    )
  }
  return (
    <Container>
      <Title data-qa={SearchQA.GridTitleNameTrending}>{t(`${TP}.trending`, 'Trending')}</Title>
      <PageLevelInstantSearch
        resultsState={resultsState}
        indexName={AlgoliaIndex.Trending}
        searchClient={AlgoliaSearchClient}
      >
        <ProductHits />
      </PageLevelInstantSearch>
      <SeeAllButtonContainer>
        <Button buttonType="primary1" data-qa={SearchQA.GridShopAllTrendingLink} href="/trending">
          {t(`${TP}.shopAllTrending`, 'Shop All Trending')}
        </Button>
      </SeeAllButtonContainer>
    </Container>
  )
}

export default TrendingProducts

const Container = styled.div`
  ${pageWidth}
  margin: 0 ${styles.mobilePageLayoutPadding};
  padding-top: 60px;
  padding-bottom: 60px;
  ${media.large`
    margin: auto;
  `}
`

const Title = styled.h2`
  ${fonts.HEADER_1}
  margin-top: 0;
`

const SeeAllButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0 10px;
  ${media.large`
    margin-top: 30px;
  `}
`
